<template>
  <system-custom-notifications-step :overflow="true" :sidebar="true">
    <template v-slot:content>
      <h4 class="custom-notification__heading">Send Notification</h4>
      <div class="send custom-notification__container">
        <div v-if="data.nexmo.selected">
          <h2>SMS Options</h2>
          <p>Are you sure you want to send your message to {{ selectedStars.length }} talent at $0.07 per {{ $starLabel }}?</p>
          <textarea
            name="text"
            class="form-control"
            rows="2"
            ref="nexmo_message"
            maxlength="160"
            :placeholder="data.nexmo.text"
            :disabled="true"/>
          <small>{{ data.nexmo.text.length }} of 160 characters</small><br/>
        </div>
        <div v-if="data.onesignal.selected || data.email.selected">
          <h2>Notification Options</h2>
          <p>Are you sure you want to send your message to {{ selectedStars.length }} {{ $starLabelPlural }}?</p>
          <h3
            v-if="data.onesignal.selected && (!data.email.selected || (data.email.selected && !data.email.subject_same))">
            Push Notification Heading</h3>
          <h3 v-else-if="data.onesignal.selected">Push Notification and Email Heading</h3>
          <textarea
            v-if="data.onesignal.selected"
            name="text"
            class="form-control"
            rows="2"
            ref="onesignal_heading"
            :placeholder="data.settings.heading"
            :disabled="true"/>
          <br/>

          <h3
            v-if="data.onesignal.selected && (!data.email.selected || (data.email.selected && !data.email.content_same))">
            Push Notification Content</h3>
          <h3 v-else-if="data.onesignal.selected">Push Notification and Email Content</h3>
          <textarea
            v-if="data.onesignal.selected"
            name="text"
            class="form-control"
            rows="2"
            ref="onesignal_heading"
            :placeholder="data.settings.content"
            :disabled="true"/>
          <br/>

          <h3 v-if="data.email.selected && !data.email.subject_same">Email Heading</h3>
          <textarea
            v-if="data.email.selected && !data.email.subject_same"
            name="text"
            class="form-control"
            rows="2"
            ref="onesignal_heading"
            :placeholder="data.email.heading"
            :disabled="true"/>
          <br/>

          <h3 v-if="data.email.selected && !data.email.content_same">Email Content</h3>
          <redactor
            v-if="data.email.selected && !data.email.content_same"
            type="text"
            class="form-control"
            name="email_content"
            ref="email_content"
            rows="2"
            :disabled="true"
            v-model="data.email.content"/>
          <br/>
          <div v-if="data.settings.link_notification">
            <h3>Push Notification Link</h3>
            <textarea
              name="text"
              class="form-control"
              rows="2"
              ref="onesignal_heading"
              :placeholder="data.settings.link"
              :disabled="true"/>
          </div>
          <div v-if="data.settings.package_notification">
            <h3>Selected Package</h3>
            <input
              class="selectize selectize-single form-control"
              name="tag_type"
              :placeholder="selectedPackage"
              :disabled="true"/>
          </div>
          <div v-if="data.settings.response_notification">
            <h3>Available Responses</h3>
            <ul
              v-for="(suboption, index) in data.settings.button_items"
              :key="index"
              class="item-detail">
              <div class="row">
                <div class="col-sm-4">
                  <input
                    name="text"
                    class="form-control"
                    ref="onesignal_response"
                    :placeholder="data.settings.button_items[index].button_text"
                    :disabled="true"
                  />
                </div>
                <div class="col-sm-8">
                  <tags type="theme" :disabled="true" v-model="data.settings.button_items[index].tags"/>
                </div>
              </div>
              <br/>
            </ul>
            <div id="bottom"></div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:sidebar>
      <h2>Selected {{ $starLabelPlural | sentenceCase }}</h2>
      <ul>
        <li v-for="talent in selectedStars" :key="talent.id">
          <button>
            {{ talent.name }} <i class="fa fa-times" @click="handleRemoveTalentCallback(talent)"></i>
          </button>
        </li>
      </ul>
    </template>
    <template v-slot:cta>
      <button class="btn btn-default" type="button" @submit.prevent v-on:click="lastPage"><i class="fa fa-chevron-left"></i> Previous</button>
      <ladda-button
        :click="handleSendNotificationCallback"
        class="btn btn-primary pull-right">
        Yes, Send <i class="fa fa-send"></i>
      </ladda-button>
    </template>
  </system-custom-notifications-step>
</template>
<script>
import { find, map } from 'lodash'
import { notify } from 'utils'
import { mapActions, mapState } from 'vuex'
import stateMapper from 'mixins/filtering/state-mapper'
import SystemCustomNotificationsStep from './SystemCustomNotificationsStep'
import SystemCustomNotificationsCreateNotification from './SystemCustomNotificationsCreateNotification'
import SystemCustomNotificationsSendNotification from './SystemCustomNotificationsSendNotification'
import SystemCustomNotificationsSelectUsers from './SystemCustomNotificationsSelectUsers'
import Tags from 'components/misc/Tags'
import Redactor from 'codium-redactor'
import * as Sentry from '@sentry/browser'

export default {
  mixins: [stateMapper],

  components: {
    SystemCustomNotificationsStep,
    SystemCustomNotificationsCreateNotification,
    SystemCustomNotificationsSendNotification,
    SystemCustomNotificationsSelectUsers,
    Tags,
    Redactor
  },

  computed: {
    ...mapState('notification', ['data', 'step']),
    ...mapState('filtering', ['selectedStars']),
    ...mapState('tags', ['packages'])
  },

  data () {
    return {
      selectedPackage: null
    }
  },

  mounted () {
    try {
      this.$refs.email_content.$el.parentNode.childNodes[2].contentEditable = false
    } catch (e) {
      Sentry.captureException(e)
    }
  },

  methods: {
    ...mapActions('notification', ['removeUser', 'sendNotification', 'nextPage', 'lastPage', 'firstPage', 'resetForm']),
    ...mapActions('filtering', ['removeSelectedStar']),

    /**
     * Handle removing talent from the array of additional talent.
     *
     * @return void
     */
    handleRemoveTalentCallback (talent) {
      this.removeSelectedStar(talent.id)
    },

    handleSendNotificationCallback () {
      let channels = []
      if (this.data.nexmo.selected) {
        channels.push('nexmo')
      }
      if (this.data.onesignal.selected) {
        channels.push('onesignal')
      }
      if (this.data.email.selected) {
        channels.push('mail')
      }
      const payload = {
        channels: channels,
        users: map(this.selectedStars, user => user.id),
        data: this.data
      }

      return this.sendNotification(payload).then((response) => {
        this.resetForm()
        this.firstPage()
        if (isNaN(response.data)) {
          notify.success('Successfully sent notification')
        } else {
          this.$router.push({ name: 'system.notifications.show', params: { id: response.data } })
        }
      }).catch((error) => { notify.error(error.message) })
    }
  },

  created () {
    this.selectedPackage = find(this.packages, existing => existing.id === this.data.settings.package)
    this.selectedPackage = this.selectedPackage ? this.selectedPackage.name : null
  }
}
</script>

<style lang="scss" scoped>
  .custom-notification__heading {
    margin-bottom: 60px;
    padding: 0 30px;
  }
</style>
